import type { RouteMode } from "../../router";
import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isCelestiaV2Path(pathname = currentPathname()): boolean {
  return isPlatformGamePath("celestia", pathname);
}

export function resolveCelestiaRouteMode(
  pathname = currentPathname(),
): RouteMode {
  return isCelestiaV2Path(pathname) ? "v2" : "legacy";
}

export function resolveCelestiaGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isCelestiaV2Path(pathname) ? "game-platform" : "legacy";
}
